import React from 'react';
import InstitutionsPage from "./InstitutionsPage";

const SuperAdminDashboard = () => {
   return <InstitutionsPage />
}

export default SuperAdminDashboard;